import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';

const endpoint = () => `${apiUtils.getBaseUri()}/wishlists`;

// TODO: Is missing get method in API from BE
const loadAllWishlists = async filterName => {
    const uri = `${endpoint()}?fields=FULL&sort=${filterName}`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load wishlists (${response.status})`);
    }
    return await response.json();
};

const moveToWishlist = async () => {
    const uri = `${endpoint()}`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to move product to wishlist (${response.status})`);
    }
    return await response.json();
};

export default {
    loadAllWishlists,
    moveToWishlist,
};
